import * as WEBIFC from "web-ifc";
import IFCTypeToOBCategoryConverter from "./DataConverters/IFCTypeToOBCategoryConverter";
import OBCategoryToColorConverter from "./DataConverters/OBCategoryToColorConverter";

export default class OBConstantsManager{

    constructor()
    {
        this.relevanttypes = {
            Wall: WEBIFC.IFCWALL,
            Slab: WEBIFC.IFCSLAB,
            Pipesegment: WEBIFC.IFCPIPESEGMENT,
            Ductsegment: WEBIFC.IFCDUCTSEGMENT,
            Ductdamper: WEBIFC.IFCDAMPER,
            Controller: WEBIFC.IFCCONTROLLER,
            Cablesegment: WEBIFC.IFCCABLESEGMENT,
            CablecarrierSegment: WEBIFC.IFCCABLECARRIERSEGMENT,
            Flowsegment: WEBIFC.IFCFLOWSEGMENT,
            Flowcontroller: WEBIFC.IFCFLOWCONTROLLER,
            Standardwall: WEBIFC.IFCWALLSTANDARDCASE,
            Buildingelement: WEBIFC.IFCBUILDINGELEMENTPROXY,
            Distributionelement: WEBIFC.IFCDISTRIBUTIONCONTROLELEMENT,
            // Insulation: WEBIFC.IFCCOVERING,

            };

        this.ifctypeconverter = new IFCTypeToOBCategoryConverter();
        this.categorycolorconverter = new OBCategoryToColorConverter();

        this.clashlistName = "IFC CLASHES";
    }



}